import { useEffect, useRef, useCallback } from 'react';
import { IUserPresence, useUserActions } from '@/features/user/stores/user.store';
import { IUseSocketReturn } from '@/websockets/hooks/use-socket';
import { TSatisfyClientToServerEvents } from '@/websockets/contexts/socket.context';

export type TUserPresenceServerToClientEvents = {
  user_presence: (payload: IUserPresence[]) => void;
};

export function useUserPresenceListeners(
  socket: IUseSocketReturn<TUserPresenceServerToClientEvents, TSatisfyClientToServerEvents>
) {
  // HOOKS
  const eventListenersAttached = useRef(false);
  const { setUserPresence } = useUserActions();

  // HELPERS
  const handleUserPresenceUpdate = useCallback(
    (payload: IUserPresence[]) => {
      setUserPresence(payload);
    },
    [setUserPresence]
  );

  // EFFECTS
  useEffect(() => {
    if (!socket?.isConnected || eventListenersAttached.current) return;

    socket.on('user_presence', handleUserPresenceUpdate);
    eventListenersAttached.current = true;

    return () => {
      socket.off('user_presence', handleUserPresenceUpdate);
      eventListenersAttached.current = false;
    };
  }, [socket, handleUserPresenceUpdate]);

  return null;
}
